import http from "./httpServices";

export async function createClient(params) {
  try {
    const res = await http.post("/clients.php", params);
    return res;
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getClients(params) {
  try {
    const res = await http.post("/getClients.php", { companyId: params });
    return res.data;
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function deleteClient(params) {
  try {
    const res = await http.post("/deleteClient.php", params);
    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export async function editClient(params) {
  try {
    const res = await http.post("/editClient.php", params);
    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export async function createClientAccess(params) {
  try {
    const res = await http.post("/createClientAccess.php", params);
    return res.data;
  } catch (err) {
    console.error("Create client access error:", err);
    throw err;
  }
}

export async function getClientAccesses(params) {
  try {
    const res = await http.post("/getClientAccesses.php", params);
    return res.data;
  } catch (err) {
    console.error("Fetch client accesses error:", err);
    return [];
  }
}

export async function editClientAccess(params) {
  try {
    const res = await http.post("/editClientAccess.php", params);
    return res.data;
  } catch (err) {
    console.error("Edit client access error:", err);
    throw err;
  }
}

export async function deleteClientAccess(params) {
  try {
    const res = await http.post("/deleteClientAccess.php", params);
    return res.data;
  } catch (err) {
    console.error("Delete client access error:", err);
    throw err;
  }
}

export async function sendEmail(params) {
  try {
    const res = await http.post("/sendEmail.php", params);
    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export async function uploadDocument(formData) {
  try {
    const res = await http.post("/uploadDocument.php", formData);
    return res;
  } catch (err) {
    console.error("Upload error:", err);
    return null;
  }
}

export async function savePartesDiarias(formData) {
  try {
    const res = await http.post("/savePartesDiarias.php", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res?.data || null;
  } catch (err) {
    console.error("Save partes diárias error:", err);

    if (err.response?.data) {
      return err.response.data;
    }

    return {
      success: false,
      message: "Erro ao guardar a parte diária.",
    };
  }
}

export async function getPartesDiarias(companyId, month, year) {
  try {
    const res = await http.get("/getPartesDiarias.php", {
      params: {
        company_id: companyId,
        month,
        year,
      },
    });
    return res.data;
  } catch (err) {
    console.error("Fetch partes diárias error:", err);
    return null;
  }
}

export async function editParteDiaria(params) {
  try {
    const res = await http.post("/editPartesDiarias.php", params);
    return res?.data || null;
  } catch (err) {
    console.error("Edit parte diária error:", err);
    return null;
  }
}

export async function deleteParteDiaria(parteId, companyId) {
  try {
    const res = await http.post("/deletePartesDiarias.php", {
      parte_id: parteId,
      company_id: companyId,
    });
    return res;
  } catch (err) {
    console.error("Delete parte diária error:", err);
    return null;
  }
}

export async function markParteDiariaRead(parteId, companyId) {
  try {
    const res = await http.post("/markParteDiariaRead.php", {
      parte_id: parteId,
      company_id: companyId,
    });
    return res?.data || null;
  } catch (err) {
    console.error("Mark parte diária read error:", err);
    return null;
  }
}

export async function uploadInternalArchive(formData) {
  try {
    const res = await http.post("/uploadInternalArchive.php", formData);
    return res;
  } catch (err) {
    console.error("Upload internal archive error:", err);
    return null;
  }
}

export async function getInternalArchive(companyId) {
  try {
    const res = await http.get("/getInternalArchive.php", {
      params: { company_id: companyId },
    });
    return res.data;
  } catch (err) {
    console.error("Fetch internal archive error:", err);
    return null;
  }
}

export async function deleteInternalArchive(archiveId, companyId) {
  try {
    const res = await http.post("/deleteInternalArchive.php", {
      archive_id: archiveId,
      company_id: companyId,
    });
    return res;
  } catch (err) {
    console.error("Delete internal archive error:", err);
    return null;
  }
}

export async function moveClientFileToInternalArchive(params) {
  try {
    const res = await http.post("/moveClientFileToInternalArchive.php", params);
    return res.data;
  } catch (err) {
    console.error("Move client file to internal archive error:", err);
    return null;
  }
}

export async function moveClientFileToClientArchive(params) {
  try {
    const res = await http.post("/moveClientFileToClientArchive.php", params);
    return res.data;
  } catch (err) {
    console.error("Move client file to client archive error:", err);
    return null;
  }
}

export async function restoreInternalArchiveToOrigin(params) {
  try {
    const res = await http.post("/restoreInternalArchiveToOrigin.php", params);
    return res.data;
  } catch (err) {
    console.error("Restore internal archive file to origin error:", err);
    return null;
  }
}

export async function restoreClientArchiveToOrigin(params) {
  try {
    const res = await http.post("/restoreClientArchiveToOrigin.php", params);
    return res.data;
  } catch (err) {
    console.error("Restore client archive file to origin error:", err);
    return null;
  }
}

export async function getClientArchive(companyId, clientId) {
  try {
    const res = await http.get("/getClientArchive.php", {
      params: {
        company_id: companyId,
        client_id: clientId,
      },
    });
    return res.data;
  } catch (err) {
    console.error("Fetch client archive error:", err);
    return null;
  }
}

export async function getUnreadFileCounts(params) {
  try {
    const res = await http.get("/getUnreadFileCounts.php", { params });
    return res.data;
  } catch (err) {
    console.error("Fetch unread file counts error:", err);
    return null;
  }
}

export async function markFileAsRead(params) {
  try {
    const res = await http.post("/markFileRead.php", params);
    return res.data;
  } catch (err) {
    console.error("Mark file as read error:", err);
    return null;
  }
}

export async function getDocuments(clienteId) {
  try {
    const res = await http.get("/getDocuments.php", {
      params: { cliente_id: clienteId },
    });
    return res.data;
  } catch (err) {
    console.error("Fetch documents error:", err);
    return null;
  }
}

export async function deleteDocument(documentId) {
  try {
    const res = await http.post("/deleteDocument.php", {
      document_id: documentId,
    });
    return res;
  } catch (err) {
    console.error("Delete document error:", err);
    return null;
  }
}

export async function uploadContact(formData) {
  try {
    const res = await http.post("/uploadContract.php", formData);
    return res;
  } catch (err) {
    console.error("Upload error:", err);
    return null;
  }
}

export async function getContracts(clienteId) {
  try {
    const res = await http.get("/getContracts.php", {
      params: { cliente_id: clienteId },
    });

    return res.data;
  } catch (err) {
    console.error("Fetch contract error:", err);
    return null;
  }
}

export async function deleteContract(contractId) {
  try {
    const res = await http.post("/deleteContract.php", {
      contract_id: contractId,
    });
    return res;
  } catch (err) {
    console.error("Delete contact error:", err);
    return null;
  }
}

export async function uploadService(formData) {
  try {
    const res = await http.post("/uploadService.php", formData);
    return res;
  } catch (err) {
    console.error("Upload error:", err);
    return null;
  }
}

export async function getServices(clienteId) {
  try {
    const res = await http.get("/getServices.php", {
      params: { cliente_id: clienteId },
    });

    return res.data;
  } catch (err) {
    console.error("Fetch services error:", err);
    return null;
  }
}

export async function deleteService(serviceId) {
  try {
    const res = await http.post("/deleteService.php", {
      service_id: serviceId,
    });
    return res;
  } catch (err) {
    console.error("Delete service error:", err);
    return null;
  }
}

// Create message
export async function createMessage(data) {
  console.log("data", data);
  try {
    const res = await http.post("/createMessage.php", data);
    return res.data;
  } catch (err) {
    console.error("Create message error:", err);
    return null;
  }
}

// Get messages by topic
export async function getMessages(companyId, clientId, lockData = {}) {
  try {
    const res = await http.post("/getMessage.php", {
      company_id: companyId,
      client_id: clientId,
      ...lockData,
    });

    return res.data;
  } catch (err) {
    console.error("Get messages error:", err);
    throw err;
  }
}

export async function releaseChatLock(data) {
  try {
    const res = await http.post("/releaseChatLock.php", data);
    return res.data;
  } catch (err) {
    console.error("Release chat lock error:", err);
    return null;
  }
}

export async function getChatLockStatus(data) {
  try {
    const res = await http.post("/chatLockStatus.php", data);
    return res.data;
  } catch (err) {
    console.error("Get chat lock status error:", err);
    return null;
  }
}

export async function getChatUnreadCount(params) {
  try {
    const res = await http.get("/getChatUnreadCount.php", { params });
    return res.data;
  } catch (err) {
    console.error("Get chat unread count error:", err);
    return null;
  }
}

export async function markChatRead(data) {
  try {
    const res = await http.post("/markChatRead.php", data);
    return res.data;
  } catch (err) {
    console.error("Mark chat read error:", err);
    return null;
  }
}

export async function getCompanyAccesses(companyId) {
  try {
    const res = await http.post("/getCompanyAccesses.php", { companyId });
    return res.data;
  } catch (err) {
    console.error("Fetch company accesses error:", err);
    return [];
  }
}

export async function createCompanyAccess(params) {
  try {
    const res = await http.post("/createCompanyAccess.php", params);
    return res.data;
  } catch (err) {
    console.error("Create company access error:", err);
    throw err;
  }
}

export async function editCompanyAccess(params) {
  try {
    const res = await http.post("/editCompanyAccess.php", params);
    return res.data;
  } catch (err) {
    console.error("Edit company access error:", err);
    throw err;
  }
}

export async function deleteCompanyAccess(params) {
  try {
    const res = await http.post("/deleteCompanyAccess.php", params);
    return res.data;
  } catch (err) {
    console.error("Delete company access error:", err);
    throw err;
  }
}

// Upload file
export async function uploadChatFile(formData) {
  try {
    const res = await http.post("/uploadChatFile.php", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (err) {
    console.error("Upload file error:", err);
    return null;
  }
}

export async function getComunicados() {
  try {
    const res = await http.get("/getComunicados.php");
    return res?.data?.data || [];
  } catch (err) {
    console.error("Fetch comunicados error:", err);
    return [];
  }
}

export async function getEventCalendars(params) {
  try {
    const res = await http.post("/getEventCalendars.php", params);
    return res.data;
  } catch (err) {
    console.error("Fetch event calendars error:", err);
    throw err;
  }
}

export async function saveEvent(params) {
  try {
    const res = await http.post("/saveEvent.php", params);
    return res.data;
  } catch (err) {
    console.error("Save event error:", err);
    throw err;
  }
}

export async function deleteEvent(params) {
  try {
    const res = await http.post("/deleteEvent.php", params);
    return res.data;
  } catch (err) {
    console.error("Delete event error:", err);
    throw err;
  }
}

export async function getLogs(params) {
  try {
    const res = await http.post("/getLogs.php", params);
    return res.data;
  } catch (err) {
    console.error("Fetch logs error:", err);
    throw err;
  }
}

export async function getAgtComunicados(params) {
  try {
    const res = await http.get("/getAgtComunicados.php");
    return res.data;
  } catch (err) {
    console.error("Fetch unread comunicados count error:", err);
    return null;
  }
}
